<script>
export default {
  props: {
    id: { type: String, required: true },
    item: { type: Object, required: true },
    eventBus: { type: Object, required: false },
  },
  methods: {
    sortMenu(a, b) {
      if (a.label == b.label) {
        return 0;
      }
      return a.label < b.label ? -1 : 1;
    },
    doAction(action) {
      if (this.eventBus) {
        this.eventBus.$emit("menu-action", action, this.item);
      } else {
        this.$emit("menu-action", action, this.item);
      }
    },
    showDetailsPane(tab) {
      if (this.eventBus) {
        this.eventBus.$emit("show-details-pane", this.item, tab);
      } else {
        this.$emit("show-details-pane", this.item, tab);
      }
    },
    showError(msg) {
      this.$modal("AlertModal", {
        alert: {
          type: "danger",
          message: msg,
        },
      })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>